import styled from 'styled-components';

export const Container = styled.div`
  .legend-square {
    width: 14px;
    height: 14px;
  }
  .calendar-cursor {
    cursor: pointer;
  }
  .bg-calendar-active {
    background: ${(props) => props.theme.$primary_green};
  }
  .bg-calendar-active:hover {
    background: ${(props) => props.theme.$green};
  }
  .filter-input {
    position: relative;
    z-index: 10;
  }
  .filter-input .css-26l3qy-menu,
  .filter-input [class*='-menu'] {
    z-index: 10;
  }
  .filter-count-tag {
    background-color: ${(props) => props.theme.$gray600};
    color: ${(props) => props.theme.$white};
    font-weight: 600;
    white-space: nowrap;
  }
  .bulletin-calendar-wrapper {
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 0.5rem;
    overflow: hidden;
  }
  .fc .fc-scrollgrid {
    border: none;
  }
  .fc .fc-col-header-cell {
    background-color: ${(props) => props.theme.$gray200};
    border-left: none;
    border-right: none;
    padding: 0.65rem 0;
  }
  .fc .fc-col-header-cell-cushion {
    color: ${(props) => props.theme.$gray700};
    font-weight: 400;
    font-size: 0.8rem;
  }
  .fc .fc-daygrid-day {
    background-color: ${(props) => props.theme.$white};
  }
  .fc .fc-daygrid-day-frame {
    min-height: 125px !important;
    height: 125px;
  }
  .fc .fc-daygrid-body-natural .fc-daygrid-day-events {
    margin-bottom: 0;
    min-height: 0;
  }
  .fc .fc-daygrid-day-events {
    min-height: 0 !important;
  }
  .fc .fc-daygrid-day-bottom {
    margin-top: 0;
  }
  .fc .fc-scrollgrid-sync-table {
    height: auto !important;
  }
  .fc .fc-daygrid-day-top {
    margin: 3px 0 0 5px;
    flex-direction: row;
    justify-content: flex-start;
  }
`;
